import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  height: 100%;\n\n  @media (max-width: 1200px) {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: auto;\n    transform: translateY(-50%);\n  }\n  @media (max-width: 768px) {\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 48px;\n  font-weight: bold;\n  line-height: 1.5;\n  color: #fff;\n  margin: 0;\n\n  @media (max-width: 1200px) {\n    font-size: 36px;\n  }\n  @media (max-width: 768px) {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n  padding: 80px 0;\n  background-color: #281284;\n\n  .hero_container {\n    height: 100%;\n    max-width: 996px;\n    padding: 0;\n    margin: 0 auto;\n\n    img {\n      display: block;\n      flex: 1;\n      width: 100%;\n      max-width: 688px;\n      margin: 0 auto;\n      object-fit: cover;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    height: 280px;\n    padding: 0;\n\n    .hero_container {\n      position: relative;\n      display: block;\n\n      img {\n        width: 80%;\n        margin: 0 auto;\n      }\n    }\n  }\n  @media (max-width: 768px) {\n    height: 150px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
const HeroInner = styled.div.withConfig({
    componentId: "sc-32bb5e65-0"
})(_templateObject());
const HeroTitle = styled.h1.withConfig({
    componentId: "sc-32bb5e65-1"
})(_templateObject1());
const HeroWrapper = styled.div.withConfig({
    componentId: "sc-32bb5e65-2"
})(_templateObject2());
export const ProtectHero = (param)=>{
    let {} = param;
    return /*#__PURE__*/ _jsx(HeroWrapper, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "hero_container",
            children: /*#__PURE__*/ _jsx(HeroInner, {
                children: /*#__PURE__*/ _jsxs(HeroTitle, {
                    children: [
                        "R인증은 교육 콘텐츠의 ",
                        /*#__PURE__*/ _jsx("br", {}),
                        "저작권을 보호합니다."
                    ]
                })
            })
        })
    });
};
